

function ObjectController(Object, createMode, $scope, $state, $q, $injector, FormService, $translate, ApiRootUrl) {

	var self = this;
	this.Object = $scope.object = Object;
	this.Class = Object.getClass();
	this.createMode = createMode;
	this.message = null;
	this.apiRootUrl = ApiRootUrl;	
	
	//this.Module = ModuleService.getModule(Object.__classname);
	
	/************** viewing ****************/
	
	this.actions = Object.get_forms('Action');
	
	this.activate_form = function(form, formdata) {
		if (typeof form == 'string') {
			form = Object.get_form(form);
		}
		return FormService.activateFormModal(form, formdata).then(function(){
			self.Object.fetch(true);
		});
	}
	this.activate_module_action = function(action) {
		return $injector.invoke(action.action, null, {Object:self.Object});
	}

	this.test_action_condition = function(condition_test) {
		if (!condition_test) return true;
		return $injector.invoke(condition_test, null, {Object:self.Object});
	}
	
	this.is_field_visible = function(field) {
		var enabled = (field.enable)? $scope.$eval(field.enable, this.Object): true;
		var visible = this.Object.has_perm(field.viewperm);
		return enabled && visible;
	}
	
	this.is_field_editable = function(field) {
		var is_fixed = false;  //this.Module.isFixedField(field.name);
		//var is_object_editable = object && object.__perms && object.__perms.edit;
		var is_field_editable = this.Object.has_perm(field.editperm);
		//return !is_fixed && is_object_editable && is_field_editable;
		return !is_fixed && is_field_editable;
	}
    
    
    
    /************** editing ****************/
	
	this.saving = false;
	this.last_saved = null;
	this.field_errors = {};
	
	this.failure = function(error) {
		if (!error) return;
		self.message = {type:'danger', body: $translate.instant(error.data.message)}
		if (error.data.code == 401) {
			$scope.$emit('unauthorized');
		}
		if (error.data.code == 1) {
			self.message.type='warning';
		}
	}
	
	this.validate = function() {
		var data = self.Class.getObjectPayload(self.Object);
		return self.Class.validate(data).then(function(result) {
			self.field_errors = {};
			return result;
		},function(error){
			self.field_errors = error.data.data;
			return $q.reject(error);
		});
	}
	
	this.save = function(group, payload /* optional */) {
		return self.Object.save(group, payload).then(function(result){
			self.field_errors = {};
			return result;
		},function(error){
			self.field_errors = error.data.data;
			return $q.reject(error);
		});
	}
	
	this.saveEdit = function(group, go_to, payload /* optional */){
		this.saving = true;
		this.last_saved = null;
		
		//return self.validate().then(function(result){
		//	console.debug('Validation successful, saving ...');
			
		return self.save(group, payload).then(function(result){
				console.debug('Save successful.');
			
				self.last_saved = new Date;
				self.saving = false;
				self.message = {type:'success', body:'Saved at {{last_saved|date:"HH:mm:ss"}}', parameters: {last_saved: self.last_saved}}
			
				$scope.$emit('afterSave', go_to, result);
				return result;
			//});
		}).catch(function(error){	
			console.debug('Validation or save failed.');
			self.saving = false;
			self.failure(error);
			return $q.reject(error);
		});
		
	}
    
    this.cancelEdit = function(){
		this.last_saved = false;
		this.Object.rollback();
		this.error = false;
		this.field_errors = {};
		this.message = null;
		$scope.$emit('afterCancelEdit');
	}
	
	this.resetForm = function(oForm) {
	    if (oForm) {
			oForm.$setPristine();
			oForm.$setUntouched();
	    }		
	}


	/************** editing (forms) ****************/

	this.last_saved = null;
	this.message = null;
	this.prepared_forms = [];
	this.prepareForm = function(savegroups, layout) {
		var savegroups = savegroups || ['edit'];
		if (typeof savegroups == "string") savegroups = [savegroups];
		var payloadgroups = angular.copy(savegroups);
		payloadgroups.push('essential');
		var layout = layout || [
			['edit-l', 'edit-r'],
			['edit-w']
		]
		var fields = this.Class.get_fields(savegroups)
		var formconfig = {
			options: {savegroups: savegroups, payloadgroups: payloadgroups},  // (form.config.options.savegroups)
			params: this.Class.get_form_params(this.Object, fields),
			submit: function(data) {
				return self.Object.save(savegroups, data);
			},
			layout: layout,
		}
		var values = this.Class.getObjectPayload(this.Object, payloadgroups);
		var form = FormService.createForm(formconfig, values);
		this.prepared_forms.push(form);
		return form;
	}
	$scope.$on('object-reload', function(){
		for (var i in self.prepared_forms) {
			var form = self.prepared_forms[i];
			self.cancelForm(form);
		}
	})

	this.saveForm = function(form, go_to){
		this.last_saved = null;
		this.message = null;
		return form.submit().then(function(result){
			console.debug('Save successful.');
			self.last_saved = new Date();
			self.message = {type:'success', body:'Saved at {{last_saved|date:"HH:mm:ss"}}', parameters: {last_saved: self.last_saved}}
			form.reset(self.Class.getObjectPayload(self.Object, form.config.options.payloadgroups));
			$scope.$emit('afterSave', go_to, result);
 			return result;
		}).catch(function(error){	
			console.debug('Save failed.');
			self.message = {type:'danger', body: error.data.message, parameters: error.data.data}
			if (error.data.code == 1) {
				self.message.type='warning';
			}
			return $q.reject(error);
		});
		
	}

	this.cancelForm = function(form) {
		this.last_saved = null;
		this.message = null;
		if (form) {
			form.reset(self.Class.getObjectPayload(self.Object, form.config.options.payloadgroups));
		}
		$scope.$emit('afterCancelEdit');
	}

	/************** end editing ****************/
	
	window.oCtrls = window.oCtrls || [];
	window.oCtrls.push(this);


    
}



























function ModuleObjectController(ListContext, $state, Object, createMode, ModesAllowed, Mode, ContextService, $scope, scrollTo, $translate, $uibModal, $timeout) {

	var self = this;
	this.Object = Object;
	this.ListContext = ListContext;
	this.Class = ListContext.getClass();  // Person
	this.EffectiveTime = ListContext.getEffectiveTime();  // null
	this.createMode = createMode;
	this.title = ListContext.getTitle();
	this.ntitle = ListContext.getListTitle();
	this.name = ListContext.getName();
	this.icon = ListContext.getIcon();
	window.$state = $state;
	
	this.tabsLeft = ListContext.getTabs('left');
	this.tabsRight = ListContext.getTabs('right');
	this.refsInline = ListContext.getRefs('inline');
	this.refsSide = ListContext.getRefs('side');
	this.refsBottom = ListContext.getRefs('bottom');
	
	this.getBreadcrumbs = function() {
		var path = [];
		var object = this.Object;
		if (object) {
			object = object.get_parent();
			while (object) {
				var ctx = ContextService.getContext(object.__classname, self.EffectiveTime);
				path.splice(0, 0, {
					page: ctx.getName(),
					module_title: ctx.getListTitle(),
					vid: object.__vid,
					title: object.__title
				});
				object = object.get_parent? object.get_parent(): null;
			}
		}
		return path;
	}
	this.breadcrumbs = this.getBreadcrumbs()
	
	this.reload = function() {
		return self.Object.fetch(true, ListContext.config.fetchLevel).then(function(){
			self.ObjectPerms = self.Object.__perms
			self.breadcrumbs = self.getBreadcrumbs()
    		$scope.$broadcast('object-reload');
    	});
	}
	
	/************** view, edit tabs ****************/
	
	
	this.viewTab = Mode;
	self.initialViewTab = Mode
	this.ModesAllowed = ModesAllowed;
	this.enableTab = {};  // do opóżnionego ładowania tab-ów
	this.enableTab[this.viewTab] = true;
	
	this.setViewTab = function(name) {
		this.viewTab = null;
		$timeout(function(){
			self.viewTab = name;
			self.enableTab[name] = true;
			setTimeout(function(){
				// event w ramach timeout, aby załadowały się kontent (FIXME - co jeśli to trwa dłużej niż 10 ms?)
				$scope.$broadcast(name+'TabOn');
			});
			$state.go('.', {mode:name}, {location:'replace', notify: false})
		})
	}
	
	if (this.tabsSide && this.tabsSide.length && !createMode) {
		// przekieruj na pierwszy tab
		if ($state.is("module.detail")) {
			$state.go(".tab", {tab: this.tabsSide[0].name}, {inherit: true, notify: true});
		}
	}
	
	
	$scope.$on('action-complete', function(){
		// zamknięcie formularza = relaod
    	self.reload();
    });
    

	
	// utility
    
    // for the historical warning object-detail
    this.vid2date = function(vid) {
 		if (!vid) return '';
 		var date = vid.replace(/[0-9]+:/, '');
 		if (date[0] == '@') return moment(date.replace('@',''), 'X').format('YYYY-MM-DD HH:mm:ss') 
 		return  moment(date).format('YYYY-MM-DD HH:mm:ss');
 	}
 	
 	// oCtrl api
 	
 	this.onAfterCancelEdit = function() {
 		if (self.createMode || self.initialViewTab == 'edit') {
			window.history.back();
		} else {
			self.setViewTab(self.initialViewTab);
			scrollTo(0,0);
		}
	}
    $scope.$on('afterCancelEdit', this.onAfterCancelEdit);
    
    
    this.onAfterSave = function($event, go_to, results) {
    	if (self.createMode) {
			if (go_to == 'go_object') {
				console.debug('go-object');
				self.Object.fetch(true, ListContext.config.fetchLevel).then(function(){
					$state.go('module.detail', {page:self.name, vid: self.Object.__vid});
				});
			}
			if (go_to == 'go_list') {
				console.debug('go-list');
				//$state.go('^.list');
				window.history.back();
			}
		} else {
			self.setViewTab(self.initialViewTab);  // przejdź do głównej zakładki info lub edit
			scrollTo(0,0);
			if (ListContext.config.fetchLevel > 1) {
				self.reload();
			} else {
				$scope.$broadcast('object-reload');
			}
		}
    }
    $scope.$on('afterSave', this.onAfterSave);
    
    /************** deleting ****************/
	
	this.deleteModal = function() {
		var del = function() {
			return self.Object.delete();
		}
		
		var dlg = $uibModal.open({
		      animation: true,
		      templateUrl: 'framework/partials/admin/object-delete.html',
		      controller: 'SubmitCancelDialogCtrl as dCtrl',
		      size: 'md',
		      resolve: {
		        params: function (ContextService, $q) {
		          return $q.all({
		          	data: self.Object,
		          	submit:del,
		          	remove_dependencies: self.Object.list_remove_dependencies(),
		          	getContext: function(classname) {return ContextService.getContext(classname)}
		          });
		        }
		      }
		});
		
		return dlg.result.then(function(){
			window.history.back();
			$timeout(function(){
				//if ($state.is("module.detail") || $state.is("module.detail.tab")) {
				if ($state.params.vid == self.Object.__vid) {
					$state.go("module.list");
				}
			},1000);
			/*if ($state.is("module.detail") || $state.is("module.detail.tab")) {
				$state.go("module.list");
			} else {
				window.history.back();
			}*/
		},self.failure);
	}
	
	
	
	window.$mScope=$scope;
	window.mCtrl=this;
	window.oCtrls = [];  // prevent stacking of oCtrls
}


angular.module('admin')
.controller('ObjectController', ObjectController)
.controller('ModuleObjectController', ModuleObjectController)


